import React, { useRef, useEffect } from "react";
import { useThree, useRender, useFrame, extend } from "react-three-fiber";
import useStore from "../store";
import * as dat from "dat.gui";
import Stats from "stats.js";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

extend({ OrbitControls });

var stats = new Stats();
stats.showPanel(0);
document.body.appendChild(stats.dom);

const DebugOrbitControls = () => {
  const { camera, gl } = useThree();
  const ref = useRef();

  useFrame(() => {
    ref.current.update();
  })
  return (
    <orbitControls
      ref={ref}
      args={[camera, gl.domElement]}
      enablePan={true}
      enableZoom={true}
    />
  )
}

const Debugger = () => {
  const debug = useStore(state => state.debug);
  const debugActions = useStore((state) => state.debugActions);
  
  const localValues = {
    blur: 0.0
  }

  const debugFunctions = {
    arrows: () => debugActions.toggle("arrows"),
    orbitControls: () => debugActions.toggle("orbitControls"),
    fixedCameraControls: () => debugActions.toggle("fixedCameraControls"),
    logging: () => debugActions.toggle("logging"),
    ambient: () => debugActions.toggle("ambient"),
  };

  useEffect(() => {
    window.gui = new dat.GUI();
    window.gui
      .add(debugFunctions, "orbitControls")
      .name("Toggle Orbit Controls");
    window.gui.add(debugFunctions, "fixedCameraControls").name("Toggle Fixed Camera Controls");
    window.gui.add(debugFunctions, "arrows").name("Toggle Arrows");
    window.gui.add(debugFunctions, "logging").name("Toggle Logging");
    window.gui.add(debugFunctions, "ambient").name("Toggle Ambient Light");
    const blurSlider = window.gui.add(localValues, "blur", 0, 1.0).name("Toggle Blur");

    blurSlider.onChange(val => {
      debugActions.set('blur', val);
    })
  }, []);

  useRender(() => {
    stats.begin();
    stats.end();
  }, true);

  return (
    <>
      { debug.orbitControls && <DebugOrbitControls /> }
    </>
  );
};

export default Debugger;
